import { ProductSorting } from '@Globals/Algolia/Types'

export const getSortLabel = (sortKey: ProductSorting, filterMostSold?: boolean) => {
  if (sortKey === 'latest') {
    return 'products:FILTER_NEWEST'
  }
  if (sortKey === 'price_desc') {
    return 'products:FILTER_EXPENSIVE'
  }
  if (sortKey === 'price_asc') {
    return 'products:FILTER_CHEAPEST'
  }
  return filterMostSold ? 'products:FILTER_MOST_SOLD' : 'header:HEADER_NAV_MOST_POPULAR_LABEL'
}
